import styled from '@emotion/styled';
import { Tab } from '@material-ui/core';
import { isInIFrame } from 'utils/services/kenticoSdk.service';

export const CustomNavbarContainer = styled.div`
  display: flex;
  flex-direction: row !important;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${isInIFrame ? '0' : '12px'};
  box-shadow: none !important;
  background-color: #fff;

  button {
    > span {
      text-transform: none !important;

      > svg {
        font-size: 20px;
        margin-right: 4px;
      }
    }
  }
`;

export const CustomNavbarTab = styled(Tab)`
  flex-grow: 1;
  min-width: unset;
  font-size: 15px;
  font-weight: 400;
  color: #2e3844;
`;
